import React from 'react'
import searchIcon from '../../assets/images/Search.png'
import filter from '../../assets/images/filter.png'
import TripItem from './TripItem'
import AddBtn from './AddBtn'
import './trips.css'
import { useNavigate } from 'react-router-dom'
import { recentTrips } from '../dummyJson'
import { useState } from 'react'

export default function Trips() {
  const [suggestions, setSuggestions] = useState(recentTrips)
  const [text, setText] = useState('')

  let searchHandle = (e) => {
    let value = e.target.value
    let searchArray = []
    if (value.length > 0) {
      const regex = new RegExp(`${value}`, 'i')
      searchArray = recentTrips.sort().filter((word) => {
        return (
          regex.test(word.trip_name) ||
          regex.test(word.email) ||
          regex.test(word.address.country) ||
          regex.test(word.address.city)
        )
      })
    }

    setSuggestions(searchArray)
    setText(value)

    if (value.length <= 0) {
      setSuggestions(recentTrips)
    }
    console.log(suggestions)
  }

  const navigate = useNavigate()
  return (
    <div className="trips-container">
      <div className="trip-item-container">
        <p className="largeTitle" style={{ marginBottom: '24px' }}>
          Trips
        </p>
        <div className="search">
          <div className="serch-input">
            <img
              src={searchIcon}
              style={{ paddingLeft: '16px' }}
              alt="search"
            />
            <input
              className="search-inp"
              type="text"
              placeholder="Search by name, email, phone"
              onChange={searchHandle}
            />
          </div>
          <img
            onClick={() => navigate('filterpage')}
            src={filter}
            alt="filter"
            className="filter-btn"
          />
        </div>

        <p
          className="headline2"
          style={{
            padding: '24px 0 16px',
            color: 'var(--gray100)',
          }}
        >
          Recently edited
        </p>
        <TripItem recentTrips={suggestions} />

        <div className="addBtn-align">
          <div className="addBtn-align">
            <AddBtn />
          </div>
        </div>
      </div>
    </div>
  )
}
